export default {"src":"/_next/static/media/eur.5a3521c2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};